import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod/v3'
import { auditorVendorSearchSchema } from '@/components/auditor-center/AuditorVendorsPage'
import { AuditorVendorDetailsPage } from '@/components/auditor-center/AuditorVendorDetailsPage'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/vendors_/$vendorId',
)({
  validateSearch: auditorVendorSearchSchema.extend({
    tab: z.enum(['overview', 'reviews']).optional(),
  }),
  component: AuditorVendorDetailsPage,
})
